module.exports = __webpack_public_path__ + "static/sid-0e67db09a05b9ab29874615dad153f62.jpeg";